// extracted by mini-css-extract-plugin
export default {"wrapper":"PovmfbNiRQ0LQUjjPqgV","description":"aWMNCOa1JO58vWdUvVrz","bold":"Ce1FGhEKIvMLypzQh9ZM","compact":"RuUsSTWeNfuaI224xVRW"};